import React, { useCallback, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TrolleyButton from 'components/auctions/AuctionVehicleCard/Header/TrolleyButton';

import * as batchActions from '../../../../redux/actions/batches';

const Header = ({
    history,
    vehicle,
    onShowDetail,
    loading,
    countDownStatus,
    trolleyCars,
    addCarToBatch,
    removeCarFromBatch,
    hideTrolley,
}) => {
    const onTrolleyButtonClick = useCallback(
        (e, addToBatch) => {
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            if (addToBatch) {
                addCarToBatch({ vehicle, history });
            } else {
                removeCarFromBatch(vehicle.Id);
            }
        },
        [addCarToBatch, vehicle, history, removeCarFromBatch]
    );

    let modelDescriptionModified = '';
    if (vehicle?.Model?.DescriptionLong && vehicle?.Brand?.Description) {
        let brandModified =
            vehicle.Brand.charAt(0).toUpperCase() +
            vehicle.Brand.toLowerCase().slice(1);
        if (vehicle.ModelLong.indexOf(brandModified) <= 0) {
            modelDescriptionModified = vehicle.ModelLong.replace(
                brandModified,
                ''
            );
            if (modelDescriptionModified) modelDescriptionModified.trim();
        }
    }
    return (
        <header className="c-card__header u-pb-none" onClick={onShowDetail}>
            <div className="o-layout">
                <div
                    className={`o-layout__item u-pl-none ${
                        hideTrolley ? '' : 'u-5/6'
                    }`}
                >
                    <p className="c-card__title">
                        {`${vehicle.Brand} ${vehicle.Model} - ${vehicle.Plate}`}
                    </p>
                    <p className="c-card__subtitle">
                        {modelDescriptionModified || vehicle.ModelLong}
                    </p>
                </div>
                {!hideTrolley ? (
                    <TrolleyButton
                        loading={loading}
                        vehicle={vehicle}
                        onTrolleyButtonClick={onTrolleyButtonClick}
                        cars={trolleyCars}
                        countDownStatus={countDownStatus}
                    />
                ) : null}
            </div>
        </header>
    );
};

const mapStateToProps = state => ({
    trolleyCars: state.carsBatch.cars, // check prop name
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({ ...batchActions }, dispatch),
});

export default memo(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
);
